export function Apply(
  props: React.SVGAttributes<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.89447 0.767036L11.0914 1.94723C11.696 2.54365 11.6904 3.47634 11.1053 4.05354L4.0981 11.0107L0.7871 11.5496C0.426678 11.6082 0.114612 11.3003 0.174056 10.9449L0.7203 7.67874L7.77314 0.767014C8.35945 0.188698 9.30829 0.188786 9.89447 0.767036ZM6.63125 3.24538L2.84772 6.9534H3.76674V8.0056H4.83341V8.91214L8.59238 5.17992L6.63125 3.24538ZM1.36383 9.7564L1.9919 10.3759L3.62714 10.1098L4.03341 9.70644V8.79475H2.96674V7.74255H2.0425L1.63361 8.14331L1.36383 9.7564ZM10.4126 3.37263L10.4138 3.37152C10.6207 3.16739 10.6193 2.84577 10.3998 2.62926L9.20307 1.44873C8.99734 1.24579 8.66776 1.24826 8.46449 1.44875L8.46338 1.44985L8.46227 1.45094L7.38796 2.5038L9.34418 4.43349L10.4115 3.37375L10.4126 3.37263ZM0.788956 12.4336C0.494404 12.4336 0.255623 12.7096 0.255623 13.0501C0.255623 13.3906 0.494404 13.6666 0.788956 13.6666H11.1001C11.3946 13.6666 11.6334 13.3906 11.6334 13.0501C11.6334 12.7096 11.3946 12.4336 11.1001 12.4336H0.788956Z"
        fill="black"
      />
    </svg>
  );
}
